import type { JsonValue } from '../serializable';
import { toJsonObject } from './build-webhook-run-input';

/**
 * Merges trigger binding defaults with the emitted payload. Named payload
 * fields are spread at the top level; `eventName` and `eventPayload` are
 * always present for listeners.
 */
export function buildEventRunInput(
  defaultInput: unknown,
  params: {
    readonly eventName: string;
    readonly payload: unknown;
  }
): { [key: string]: JsonValue } {
  const base = toJsonObject(defaultInput);
  const payloadFields = toJsonObject(params.payload);
  return {
    ...base,
    ...payloadFields,
    eventName: params.eventName,
    eventPayload: payloadFields,
  };
}
